<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M18.3.4c.3.3.4.7.4 1.1s-.2.8-.4 1.1L8.9 12l9.4 9.4c.3.3.4.7.4 1.1 0 .4-.2.8-.4 1-.3.3-.7.4-1 .4-.4 0-.8-.1-1.1-.4L5.7 13.1c-.3-.3-.4-.7-.4-1.1 0-.4.2-.8.4-1.1L16.2.4c.3-.2.7-.4 1.1-.4.4 0 .7.2 1 .4z"
    />
  </svg>
</template>
